'use client'
const isSupportedNetwork = ({ walletConnector, network }) => {
    const enabledNetworks = walletConnector.getEnabledNetworks();
    if (!enabledNetworks.length) {
        return true;
    }
    const isCurrentNetworkSupported = enabledNetworks.some(({ chainId }) => String(chainId) === String(network));
    return isCurrentNetworkSupported;
};

export { isSupportedNetwork };
